export const deliveryAddressFormUpdate = ({ prop, value }) => {

    return {
        type: 'DELIVERY_ADDRESS_FORM_UPDATE',
        field: { prop, value }
    }
};

export const deliveryAddressFormError = (message) => {
    return {
        type: 'DELIVERY_ADDRESS_FORM_ERROR',
        error: message
    };
}

export const deliveryAddressFormSuccess = () => {
    return {
        type: 'DELIVERY_ADDRESS_FORM_SUCCESS'
    };
};

export const deliveryAddressFormLoading = () => {
    return {
        type: 'DELIVERY_ADDRESS_FORM_LOADING'
    };
}

export const deliveryAddressFormReset = () => {
    return {
        type: 'DELIVERY_ADDRESS_FORM_RESET'
    };
}